function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("title", null, "ResultIcon");

var _ref3 = /*#__PURE__*/React.createElement("g", {
  id: "ResultIcon",
  stroke: "none",
  strokeWidth: 1,
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("g", {
  id: "Alerts-/-Alt-3",
  fillRule: "nonzero"
}, /*#__PURE__*/React.createElement("g", {
  id: "alerts-alt-3",
  transform: "translate(6.666667, 6.666667)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M33.3333333,46.6666667 C31.4923842,46.6666667 30,45.1742825 30,43.3333333 L30,20 C30,18.1590508 31.4923842,16.6666667 33.3333333,16.6666667 C35.1742825,16.6666667 36.6666667,18.1590508 36.6666667,20 L36.6666667,43.3333333 C36.6666667,45.1742825 35.1742825,46.6666667 33.3333333,46.6666667 Z",
  id: "Path"
}), /*#__PURE__*/React.createElement("circle", {
  id: "Oval",
  cx: 33.3333333,
  cy: 53.3333333,
  r: 3.33333333
}), /*#__PURE__*/React.createElement("path", {
  d: "M56.6666667,66.6666667 L10,66.6666667 C4.4771525,66.6666667 0,62.1895142 0,56.6666667 L0,10 C0,4.4771525 4.4771525,0 10,0 L56.6666667,0 C62.1895142,0 66.6666667,4.4771525 66.6666667,10 L66.6666667,56.6666667 C66.6666667,62.1895142 62.1895142,66.6666667 56.6666667,66.6666667 Z M10,6.66666667 C8.15905083,6.66666667 6.66666667,8.15905083 6.66666667,10 L6.66666667,56.6666667 C6.66666667,58.5076158 8.15905083,60 10,60 L56.6666667,60 C58.5076158,60 60,58.5076158 60,56.6666667 L60,10 C60,8.15905083 58.5076158,6.66666667 56.6666667,6.66666667 L10,6.66666667 Z",
  id: "Shape"
}))));

var SvgQuestionnaireResultIcon = function SvgQuestionnaireResultIcon(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 80 80",
    ref: svgRef
  }, props), title === undefined ? _ref2 : title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref3);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgQuestionnaireResultIcon, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/QuestionnaireResultIcon.67f02f56.svg";
export { ForwardRef as ReactComponent };